export const STORAGE_KEY_JWT = 'OV_JWT';
export const STORAGE_KEY_USERLOCAL = 'OV_USER';
export const STORAGE_KEY_DISCLOSURE = 'OV_TERMS_2019_11_20';
export const STORAGE_KEY_SETTINGS = 'OV_CANVASS_SETTINGS';
export const STORAGE_KEY_OLDFORMS = 'OV_CANVASS_FORMS';
export const STORAGE_KEY_RETRY = 'HV_RETRY_QUEUE';
export const STORAGE_KEY_SERVERS = 'HV_SERVERS';
export const URL_TERMS_OF_SERVICE = 'https://raw.githubusercontent.com/OurVoiceUSA/HelloVoter/master/docs/Terms-of-Service.md';
export const URL_PRIVACY_POLICY = 'https://raw.githubusercontent.com/OurVoiceUSA/HelloVoter/master/docs/Privacy-Policy.md';
export const URL_GUIDELINES = 'https://raw.githubusercontent.com/OurVoiceUSA/HelloVoter/master/docs/Canvassing-Guidelines.md';
export const URL_HELP = 'https://github.com/OurVoiceUSA/HelloVoter/blob/master/docs/Canvassing.md';
export const URL_APPLE_IOS = 'https://itunes.apple.com/us/app/our-voice-usa/id1275301651?ls=1&amp;mt=8';
export const URL_GOOGLE_PLAY = 'https://play.google.com/store/apps/details?id=org.ourvoiceinitiative.ourvoice';
